import { type Images } from '@neos/app'
import collapsePath from '../../modules/dependencies/UserPermissions.3.1.13/images/Collapse.svg'
import createCustomViewPath from '../../modules/dependencies/UICustomization.3.1.13/images/CreateCustomView.svg'
import createCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization.3.1.13/images/CreateCustomView.dark.svg'
import customViewPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomView.svg'
import customViewDefaultViewPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewDefaultView.svg'
import customViewFilterPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewFilter.svg'
import customViewGroupsPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewGroups.svg'
import customViewKeyPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewKey.svg'
import customViewPropertyPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewProperty.svg'
import customViewRelationshipPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewRelationship.svg'
import customViewSavePath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewSave.svg'
import customViewSelectedPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewSelected.svg'
import customViewSetDefaultViewPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewSetDefaultView.svg'
import customViewSortPath from '../../modules/dependencies/UICustomization.3.1.13/images/CustomViewSort.svg'
import downPath from '../../modules/dependencies/UserPermissions.3.1.13/images/Down.svg'
import editPath from '../../modules/dependencies/Theme.3.1.11/images/Edit.svg'
import editCustomViewPath from '../../modules/dependencies/UICustomization.3.1.13/images/EditCustomView.svg'
import editCustomViewDarkVersionPath from '../../modules/dependencies/UICustomization.3.1.13/images/EditCustomView.dark.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions.3.1.13/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions.3.1.13/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions.3.1.13/images/ExternalCluster.svg'
import eyePath from '../../modules/dependencies/Theme.3.1.11/images/Eye.svg'
import forbiddenPath from '../../modules/dependencies/Theme.3.1.11/images/Forbidden.svg'
import gearPath from '../../modules/dependencies/Theme.3.1.11/images/Gear.svg'
import logoPath from '../../modules/dependencies/Theme.3.1.11/images/Logo.svg'
import masterMenuPath from '../../modules/dependencies/Theme.3.1.11/images/MasterMenu.svg'
import removePath from '../../modules/dependencies/Theme.3.1.11/images/Remove.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions.3.1.13/images/RoleUsers.svg'
import styleRulePath from '../../modules/dependencies/UICustomization.3.1.13/images/StyleRule.svg'
import styleRuleDarkVersionPath from '../../modules/dependencies/UICustomization.3.1.13/images/StyleRule.dark.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions.3.1.13/images/SyncBlack.svg'
import synchronisationPath from '../../modules/dependencies/Theme.3.1.11/images/Synchronisation.svg'
import upPath from '../../modules/dependencies/UserPermissions.3.1.13/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserAccount.svg'
import userCheckPath from '../../modules/dependencies/Theme.3.1.11/images/UserCheck.svg'
import userClientPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions.3.1.13/images/UserPublisher.svg'

const images: Images = {
  collapse: { path: collapsePath, colored: false },
  createCustomView: { path: createCustomViewPath, darkVersionPath: createCustomViewDarkVersionPath, colored: true },
  customView: { path: customViewPath, colored: false },
  customViewDefaultView: { path: customViewDefaultViewPath, colored: false },
  customViewFilter: { path: customViewFilterPath, colored: false },
  customViewGroups: { path: customViewGroupsPath, colored: false },
  customViewKey: { path: customViewKeyPath, colored: false },
  customViewProperty: { path: customViewPropertyPath, colored: false },
  customViewRelationship: { path: customViewRelationshipPath, colored: false },
  customViewSave: { path: customViewSavePath, colored: false },
  customViewSelected: { path: customViewSelectedPath, colored: false },
  customViewSetDefaultView: { path: customViewSetDefaultViewPath, colored: false },
  customViewSort: { path: customViewSortPath, colored: false },
  down: { path: downPath, colored: false },
  edit: { path: editPath, colored: false },
  editCustomView: { path: editCustomViewPath, darkVersionPath: editCustomViewDarkVersionPath, colored: true },
  editUser: 'edit',
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  expand: { path: expandPath, colored: false },
  externalCluster: { path: externalClusterPath, colored: true },
  eye: { path: eyePath, colored: false },
  forbidden: { path: forbiddenPath, colored: false },
  gear: { path: gearPath, colored: false },
  info: 'info',
  logo: { path: logoPath, colored: false },
  masterMenu: { path: masterMenuPath, colored: false },
  neosPrint: 'print',
  remove: { path: removePath, colored: false },
  roleUsers: { path: roleUsersPath, colored: false },
  styleRule: { path: styleRulePath, darkVersionPath: styleRuleDarkVersionPath, colored: true },
  syncBlack: { path: syncBlackPath, colored: false },
  synchronisation: { path: synchronisationPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userCheck: { path: userCheckPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  warning: 'warning',
}

export default images